/**
 * sessionStorage Keys
 */
export const SESSION_STORAGE_KEYS = {
  /** 註冊邀請 Email */
  EMAIL: 'email',
  /** 註冊邀請 Checksum */
  CHECK: 'check',
  /** OAuth State */
  STATE: 'state',
  /** OAuth Code Verifier */
  CODE_VERIFIER: 'code_verifier',
  /** 前一個路由名稱 */
  PREV_URL_ROUTE_NAME: 'prevUrlRouteName',
  /** 被登出前的重定向路徑 */
  REDIRECT_PATH: 'redirectPath'
} as const

export type SessionStorageKey = (typeof SESSION_STORAGE_KEYS)[keyof typeof SESSION_STORAGE_KEYS]

/**
 * localStorage Keys
 */
export const LOCAL_STORAGE_KEYS = {
  /** 公司 UUID */
  COMPANY_UUID: 'companyUuid',
  /** 組織 ID */
  ORG_ID: 'orgId',
  /** 公司列表欄位設定 */
  COMPANY_FIELDS: 'companyFields',
  /** 不再顯示客戶邀請待處理提示的日期 */
  NO_SHOW_CUSTOMER_INVITATION_PENDING_TIPS: 'noShowCustomerInvitationPendingTips',
  /** 不再顯示員工邀請待處理提示的日期 */
  NO_SHOW_STAFF_INVITATION_PENDING_TIPS: 'noShowStaffInvitationPendingTips'
} as const

export type LocalStorageKey = (typeof LOCAL_STORAGE_KEYS)[keyof typeof LOCAL_STORAGE_KEYS]
